/** @format */

export default class KitKreator {
	constructor() {
		this.instance = self;
		this.editOpenedFromPopup = false;
	}

	static init() {
		const self = new KitKreator();

		self.attachEvents();
	}

	openKitModal(url) {
		const open = function () {
			$("#kit-kreator-iframe").attr("src", url);

			$.magnificPopup.open({
				items: {
					src: "#kit-kreator-modal",
					type: "inline",
				},
				mainClass: "mfp-zoom-out mod-full",
				fixedContentPos: true,
				closeOnBgClick: false,
				showCloseBtn: false,
				enableEscapeKey: true,
				callbacks: {
					open: function () {
						$("html, body").addClass("popup-open kit-kreator-popup-open");
					},
					close: function () {
						$("html, body").removeClass("popup-open kit-kreator-popup-open");
						$("#kit-kreator-iframe").attr("src", "");
					},
				},
			});
		};

		if ($.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
			$.magnificPopup.instance.close();
			setTimeout(open, 500);
		} else {
			open();
		}
	}

	refreshBasketPartials() {
		const self = this;

		if (typeof oc === "undefined" || !oc.ajax) {
			return;
		}

		oc.ajax("shopBasket::onUpdateBasketCount", {
			update: {
				"shopBasket/default": ".js-basket",
				"shopBasket/edit": ".js-basket-edit",
				"banner/delivery-banner": ".js-delivery-banner",
			},
			success: function (data) {
				const count = parseInt(data && data.basket_count);

				if (!isNaN(count)) {
					if (count > 0) {
						$(".js-basket-count").attr("data-count", count);
					} else {
						$(".js-basket-count").removeAttr("data-count");
					}
				}
			},
		});
	}

	appendWebshop(url) {
		const webshopId = $("#kit-kreator-modal").attr("data-webshop-id");

		if (!webshopId) {
			return url;
		}

		return url + "&webshop=" + encodeURIComponent(webshopId);
	}

	attachEvents() {
		const self = this;
		const $modal = $("#kit-kreator-modal");

		if (!$modal.length) {
			return;
		}

		$(document).on("click", ".js-kit-kreator-open", function (e) {
			e.preventDefault();

			const productId = $(this).data("product-id");
			const productName = $(this).attr("data-product-name");
			const isBundle = $(this).data("bundle") === 1 || $(this).data("bundle") === '1';
			const kitKreatorUrl = $modal.attr("data-kit-kreator-url");

			if (!productId || !kitKreatorUrl) {
				return;
			}

			const separator = kitKreatorUrl.indexOf("?") > -1 ? "&" : "?";
			let url = kitKreatorUrl + separator + "productId=" + encodeURIComponent(productId);

			if (productName) {
				url += "&productName=" + encodeURIComponent(productName);
			}

			if (isBundle) {
				url += "&bundle=1";
			}

			self.openKitModal(self.appendWebshop(url));
		});

		$(document).on("click", ".js-kit-kreator-edit", function (e) {
			e.preventDefault();

			const basketItemId = $(this).data("basket-item-id");
			const productId = $(this).data("product-id");
			const kitKreatorUrl = $modal.attr("data-kit-kreator-url");

			if (!basketItemId || !kitKreatorUrl) {
				return;
			}

			self.editOpenedFromPopup = !!(
				$.magnificPopup.instance && $.magnificPopup.instance.isOpen
			);

			const separator = kitKreatorUrl.indexOf("?") > -1 ? "&" : "?";
			let url =
				kitKreatorUrl +
				separator +
				"view=designer&editBasket=" +
				encodeURIComponent(basketItemId);

			if (productId) {
				url += "&productId=" + encodeURIComponent(productId);
			}

			self.openKitModal(self.appendWebshop(url));
		});

		window.addEventListener("message", function (e) {
			if (e.data && e.data.type === "kit-kreator:close") {
				$.magnificPopup.instance.close();
			}

			if (e.data && e.data.type === "kit-kreator:basket-added") {
				$.magnificPopup.instance.close();

				if (typeof window.site.updateBasketCount === "function") {
					window.site.updateBasketCount(e.data.productId);
				}
			}

			if (e.data && e.data.type === "kit-kreator:basket-updated") {
				$.magnificPopup.instance.close();
				self.refreshBasketPartials();

				if (self.editOpenedFromPopup) {
					const basketUrl = $modal.attr("data-basket-popup-url");

					if (basketUrl && typeof window.site.openAjaxPopup === "function") {
						setTimeout(function () {
							window.site.openAjaxPopup(basketUrl);
						}, 500);
					}
				}

				self.editOpenedFromPopup = false;
			}
		});
	}
}
